/**
 * EdgeNodePill — edge 양쪽 노드를 BlocksPage 의 `.shape-flow__node` 와 동일한 비주얼 언어로
 * 렌더. kind → OntologyBlock 매핑으로 `block.icon` / `block.category` 를 얻어 아이콘/색상 톤을
 * 결정하고, 블럭이 매핑되지 않은 (카탈로그 이외) kind 는 orphan 스타일로 이름만 표시한다.
 *
 * GraphTabWithPlayback 의 edge 목록과 EdgeInspector 의 헤더가 공유한다 — 모노스페이스 ID
 * 절단 표기를 전면 대체.
 */
import type { OntologyBlock } from "../../../api/admin-client.ts"
import type { GraphNode } from "../../../components/graph/types.ts"

type Props = {
	readonly node: GraphNode | undefined
	readonly fallbackId: string
	readonly kindToBlock: ReadonlyMap<string, OntologyBlock>
	/** 크기 variant — 'sm' 은 edge 목록용, 'md' 는 Inspector header 용 */
	readonly size?: "sm" | "md"
}

export function EdgeNodePill({ node, fallbackId, kindToBlock, size = "sm" }: Props) {
	const name = node?.name ?? fallbackId
	const kind = node?.kind ?? ""
	const block = kind ? kindToBlock.get(kind) : undefined
	const id = node?.id ?? fallbackId
	const fontSize = size === "md" ? "0.9rem" : undefined
	const padding = size === "md" ? "6px 12px" : undefined
	if (!block) {
		return (
			<span
				className="shape-flow__node shape-flow__node--orphan"
				title={`${id}\nkind: ${kind || "unknown"}`}
				style={fontSize ? { fontSize, padding } : undefined}
			>
				{name}
			</span>
		)
	}
	return (
		<span
			className={`shape-flow__node cat-${block.category}`}
			title={`${id}\nkind: ${kind} · block: ${block.displayName}`}
			style={fontSize ? { fontSize, padding } : undefined}
		>
			<span className="shape-flow__icon" aria-hidden>
				{block.icon}
			</span>
			<span className="shape-flow__label">{name}</span>
		</span>
	)
}
